<template>
    <div>
        Core Values, Vision & Mission
    </div>
</template>

<script>
    export default {
        name: "coreValuesMission"
    }
</script>

<style scoped>

</style>